
define('text!templates/modules/calendar/activity/detail/blocks/calories-burn.html',[],function () { return '<div class="calories-input"></div>\n';});

